import { render, staticRenderFns } from "./member-info.vue?vue&type=template&id=dade8b62&scoped=true&"
import script from "./member-info.vue?vue&type=script&lang=js&"
export * from "./member-info.vue?vue&type=script&lang=js&"
import style0 from "./member-info.vue?vue&type=style&index=0&id=dade8b62&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dade8b62",
  null
  
)

export default component.exports